import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'

import './boot/antd'

import utils from './utils/utils'
Vue.prototype.$utils = utils
Vue.prototype.$moment = moment
window.$moment = moment

import FullScreen from './plugins/fullscreen'
Vue.use(FullScreen)

import './assets/css/font-awesome.min.css'
import './style/index.styl'

import mixin from './mixins'
Vue.mixin(mixin)

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Viewer.setDefaults({
  navbar: false, //底部缩略图
  toolbar: false, //底部工具栏
  // button: false, //右上角按钮
  title: false, //当前图片标题
  movable: false, //是否可以移动
  zoomable: true, //是否可以缩放
  transition: false,
})
Vue.use(Viewer)


import VueLazyload from 'vue-lazyload'
const loadimage = require('./assets/images/loading.gif')
const errorimage = require('./assets/images/load_fail.png')

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
